import React, { useState, useEffect } from 'react'
import {
    Table,
    Input,
    Button,
    Dropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Col,
    Row,
    Card,
    CardFooter,
    CardBody,
    Label,
    FormGroup,
    CardHeader,
    CardTitle
} from "reactstrap";
import moment from 'moment'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Select from 'react-select';

import updateService from 'services/update.service'
import { useToolContext } from 'contexts/ToolContext'
import axios from 'axios'
import authHeader from 'services/auth-header'

// Special tool for Plugin page only
const SPECIAL_TOOL = { matool: 'shared', name: 'Shared' };

function formatFileSize(bytes) {
    if (!bytes || bytes === 0) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1) + ' ' + units[i];
}

function Orders() {
    const { lstTool, selectedTool, selectedToolName, setSelectedTool, isLoading } = useToolContext();
    const [plugin, setPlugin] = useState([])

    // Local dropdown state for showing special item
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);

    // Local tool state (can be special or from context)
    const [localTool, setLocalTool] = useState('');
    const [localToolName, setLocalToolName] = useState('');

    const [id, setId] = useState('')
    const [typeFile, setTypeFile] = useState('Tải lên file')

    const [localPath, setLocalPath] = useState('')

    const [lstFolder, setLstFolder] = useState([])
    const [folderSelected, setFolderSelected] = useState('')

    const [lstFile, setLstFile] = useState([])
    const [fileSelected, setFileSelected] = useState('')

    const [version, setVersion] = useState('file')
    const [log, setLog] = useState('')

    const [selectedFile, setSelectedFile] = useState('')

    // Sync local tool with context when component mounts or context changes
    useEffect(() => {
        if (!isLoading && selectedTool) {
            setLocalTool(selectedTool);
            setLocalToolName(selectedToolName);
        }
    }, [isLoading, selectedTool, selectedToolName]);

    // Load plugins when localTool changes
    useEffect(() => {
        if (localTool) {
            loadPlugin(localTool);
        }
    }, [localTool]);

    function handleToolChange(tool, toolName, isSpecial = false) {
        setLocalTool(tool);
        setLocalToolName(toolName);
        // Only save to global context if not a special item
        if (!isSpecial) {
            setSelectedTool(tool, toolName, true);
        }
    }

    const SERVER_LABELS = ['api.dhbtools.com', 'api2.dhbtools.com', 'api3.dhbtools.com'];

    const serverDataRef = React.useRef([null, null, null]);
    const baseDataRef = React.useRef([]);

    function loadPlugin(tool) {
        serverDataRef.current = [undefined, undefined, undefined];
        baseDataRef.current = [];

        const headers = { headers: authHeader() };
        const urls = [
            `${process.env.REACT_APP_MY_HOST}/v7/admin/plugin/${tool}`,
            `${process.env.REACT_APP_FORWARD_HOST}/v7/admin/plugin/${tool}`,
            `${process.env.REACT_APP_FORWARD_HOST3}/v7/admin/plugin/${tool}`,
        ];

        urls.forEach((url, i) => {
            axios.get(url, headers)
                .then(res => {
                    if (res?.data?.data) {
                        serverDataRef.current[i] = res.data.data;
                    } else {
                        serverDataRef.current[i] = [];
                    }
                })
                .catch(() => {
                    serverDataRef.current[i] = null;
                })
                .finally(() => {
                    mergeAndSetPlugin();
                });
        });
    }

    function mergeAndSetPlugin() {
        const sData = serverDataRef.current;
        const baseData = sData[0] || sData[1] || sData[2] || [];
        baseDataRef.current = baseData;

        const serverMaps = sData.map(data => {
            if (!data) return {};
            const map = {};
            data.forEach(item => { map[item.id] = item; });
            return map;
        });

        const merged = baseData.map(record => {
            const servers = SERVER_LABELS.map((label, i) => {
                if (sData[i] === null) {
                    return { label, exists: false, fileSize: null, online: false, loading: false };
                }
                if (sData[i] === undefined) {
                    return { label, exists: false, fileSize: null, online: true, loading: true };
                }
                const serverRecord = serverMaps[i][record.id];
                return {
                    label,
                    exists: serverRecord ? (serverRecord.fileSize != null && serverRecord.fileSize > 0) : false,
                    fileSize: serverRecord?.fileSize || null,
                    online: true,
                    loading: false
                };
            });
            return { ...record, servers };
        });

        setPlugin(merged);
    }

    function postPlugin() {
        let file = selectedFile;
        if (typeFile === "Chọn từ server") {
            file = folderSelected + "/" + fileSelected;
            setSelectedFile(file);
        }

        // Hiển thị Swal với 3 thanh progress
        let uploadCancelled = false;
        Swal.fire({
            title: 'Đang tải lên plugin...',
            width: '650px',
            html: `
            <style>
              .swal2-title { padding-bottom: 16px !important; }
              .swal2-actions { flex-direction: column !important; gap: 12px !important; }
              .swal2-loader { order: -1 !important; }
              .upload-server-card {
                background: #f8f9fa;
                border-radius: 10px;
                padding: 18px 18px;
                margin-bottom: 14px;
                border: 1px solid #e9ecef;
                text-align: left;
              }
              .upload-server-card.upload-success { border-color: #00b894; background: #f0fff4; }
              .upload-server-card.upload-error { border-color: #d63031; background: #fff5f5; }
              .upload-server-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 4px;
              }
              .upload-server-name {
                font-weight: 700;
                font-size: 15px;
                color: #2d3436;
              }
              .upload-server-host {
                font-size: 12px;
                color: #636e72;
                font-family: monospace;
              }
              .upload-server-info {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 10px;
                font-size: 12px;
                color: #636e72;
              }
              .upload-server-info .location-icon {
                color: #e74c3c;
              }
              .upload-dns-badge {
                background: #dfe6e9;
                padding: 2px 10px;
                border-radius: 4px;
                font-size: 11px;
                color: #636e72;
                margin-left: auto;
              }
              .upload-dns-badge.proxied {
                background: #ffeaa7;
                color: #d35400;
              }
              .upload-mb-info { font-size: 12px; color: #636e72; margin-bottom: 4px; display: flex; justify-content: space-between; align-items: center; }
              .upload-speed { color: #0984e3; font-weight: 600; }
              .upload-progress-wrapper {
                position: relative;
                width: 100%;
                height: 26px;
                background-color: #e9ecef;
                border-radius: 13px;
                overflow: hidden;
              }
              .upload-progress-bar {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                background: linear-gradient(90deg, #00b894, #00cec9);
                text-align: center;
                color: #fff;
                font-size: 11px;
                font-weight: 600;
                line-height: 26px;
                width: 0%;
                transition: width 0.4s ease;
                border-radius: 13px;
                white-space: nowrap;
                min-width: 45px;
              }
              .upload-status-msg { margin-top: 6px; font-size: 12px; font-weight: 600; display: none; }
              .upload-status-msg.success { color: #00b894; }
              .upload-status-msg.error { color: #d63031; }
              .upload-retry-btn {
                margin-top: 6px; padding: 4px 14px; font-size: 11px; font-weight: 600;
                color: #fff; background: #0984e3; border: none; border-radius: 6px;
                cursor: pointer; display: none;
              }
              .upload-retry-btn:hover { background: #0652DD; }
              .upload-timer {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 12px;
                margin-top: 10px;
                font-size: 13px;
                color: #636e72;
              }
              .upload-timer .elapsed {
                font-weight: 600;
                color: #2d3436;
              }
              .upload-timer .timeout {
                color: #d63031;
                font-weight: 600;
              }
            </style>
            <div>
              <div id="card1" class="upload-server-card">
                <div class="upload-server-header">
                  <span class="upload-server-name">Digital Ocean</span>
                  <span class="upload-server-host">api.dhbtools.com</span>
                </div>
                <div class="upload-server-info">
                  <i class="fas fa-map-marker-alt location-icon"></i>
                  <span>Singapore</span>
                  <span class="upload-dns-badge">DNS Only</span>
                </div>
                <div class="upload-mb-info" id="mbInfo1"><span class="upload-speed" id="speed1"></span><span>0.0/0.0 MB</span></div>
                <div class="upload-progress-wrapper">
                  <div id="progressBar1" class="upload-progress-bar">0%</div>
                </div>
                <div id="status1" class="upload-status-msg"></div>
                <button id="retry1" class="upload-retry-btn" onclick="window._retryUpload(0)"><i class="fas fa-redo"></i> Thử lại</button>
              </div>
              <div id="card2" class="upload-server-card">
                <div class="upload-server-header">
                  <span class="upload-server-name">Viettel IDC</span>
                  <span class="upload-server-host">api2.dhbtools.com</span>
                </div>
                <div class="upload-server-info">
                  <i class="fas fa-map-marker-alt location-icon"></i>
                  <span>Vietnam</span>
                  <span class="upload-dns-badge proxied">Cloudflare Proxied</span>
                </div>
                <div class="upload-mb-info" id="mbInfo2"><span class="upload-speed" id="speed2"></span><span>0.0/0.0 MB</span></div>
                <div class="upload-progress-wrapper">
                  <div id="progressBar2" class="upload-progress-bar">0%</div>
                </div>
                <div id="status2" class="upload-status-msg"></div>
                <button id="retry2" class="upload-retry-btn" onclick="window._retryUpload(1)"><i class="fas fa-redo"></i> Thử lại</button>
              </div>
              <div id="card3" class="upload-server-card">
                <div class="upload-server-header">
                  <span class="upload-server-name">Home Server NUC</span>
                  <span class="upload-server-host">api3.dhbtools.com</span>
                </div>
                <div class="upload-server-info">
                  <i class="fas fa-map-marker-alt location-icon"></i>
                  <span>Vietnam</span>
                  <span class="upload-dns-badge proxied">Cloudflare Proxied</span>
                </div>
                <div class="upload-mb-info" id="mbInfo3"><span class="upload-speed" id="speed3"></span><span>0.0/0.0 MB</span></div>
                <div class="upload-progress-wrapper">
                  <div id="progressBar3" class="upload-progress-bar">0%</div>
                </div>
                <div id="status3" class="upload-status-msg"></div>
                <button id="retry3" class="upload-retry-btn" onclick="window._retryUpload(2)"><i class="fas fa-redo"></i> Thử lại</button>
              </div>
            </div>
            <div class="upload-timer">
              <span><i class="fas fa-clock"></i> Đã tải lên: <span id="uploadElapsed" class="elapsed">00:00</span></span>
              <span>|</span>
              <span>Hết hạn: <span id="uploadTimeout" class="timeout">10:00</span></span>
            </div>
            `,
            allowOutsideClick: false,
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: '<i class="fas fa-times-circle"></i> Hủy tải lên',
            cancelButtonColor: '#dc3545',
            didOpen: () => {
                Swal.showLoading();
                const startTime = Date.now();
                const TIMEOUT_MS = 600000;
                window._uploadTimerInterval = setInterval(() => {
                    const elapsed = Date.now() - startTime;
                    const remaining = Math.max(0, TIMEOUT_MS - elapsed);
                    const elapsedMin = Math.floor(elapsed / 60000);
                    const elapsedSec = Math.floor((elapsed % 60000) / 1000);
                    const remainMin = Math.floor(remaining / 60000);
                    const remainSec = Math.floor((remaining % 60000) / 1000);
                    const elEl = document.getElementById('uploadElapsed');
                    const toEl = document.getElementById('uploadTimeout');
                    if (elEl) elEl.textContent = `${String(elapsedMin).padStart(2, '0')}:${String(elapsedSec).padStart(2, '0')}`;
                    if (toEl) {
                        toEl.textContent = `${String(remainMin).padStart(2, '0')}:${String(remainSec).padStart(2, '0')}`;
                        if (remaining < 60000) toEl.style.color = '#e17055';
                        if (remaining < 30000) toEl.style.color = '#d63031';
                    }
                    if (remaining <= 0) clearInterval(window._uploadTimerInterval);
                }, 1000);
            }
        }).then((result) => {
            if (window._uploadTimerInterval) clearInterval(window._uploadTimerInterval);
            if (result.dismiss === Swal.DismissReason.cancel) {
                uploadCancelled = true;
                loadPlugin(localTool);
            }
        });

        const updateCardStatus = (cardIndex, status, message) => {
            const card = document.getElementById(`card${cardIndex}`);
            const statusEl = document.getElementById(`status${cardIndex}`);
            const retryBtn = document.getElementById(`retry${cardIndex}`);
            if (!card) return;
            if (status === 'success') {
                card.classList.add('upload-success'); card.classList.remove('upload-error');
                if (statusEl) { statusEl.innerHTML = message || '<i class="fas fa-check-circle"></i> Tải lên thành công'; statusEl.className = 'upload-status-msg success'; statusEl.style.display = 'block'; }
                if (retryBtn) retryBtn.style.display = 'none';
            } else if (status === 'error') {
                card.classList.add('upload-error'); card.classList.remove('upload-success');
                if (statusEl) { statusEl.innerHTML = `<i class="fas fa-times-circle"></i> ${message || 'Tải lên thất bại'}`; statusEl.className = 'upload-status-msg error'; statusEl.style.display = 'block'; }
                if (retryBtn) retryBtn.style.display = 'inline-block';
            }
        };

        const speedTrackers = {};
        const makeProgressCallback = (barId, mbId, speedId) => (progressEvent) => {
            if (uploadCancelled) return;
            const now = Date.now();
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            const loadedMB = (progressEvent.loaded / (1024 * 1024)).toFixed(1);
            const totalMB = (progressEvent.total / (1024 * 1024)).toFixed(1);
            const bar = Swal.getPopup()?.querySelector(`#${barId}`);
            const mbInfo = Swal.getPopup()?.querySelector(`#${mbId}`);
            const speedEl = Swal.getPopup()?.querySelector(`#${speedId}`);
            if (bar) { bar.style.width = percentCompleted + '%'; bar.textContent = `${percentCompleted}%`; }
            if (mbInfo) { const mbSpan = mbInfo.querySelector('span:last-child'); if (mbSpan) mbSpan.textContent = `${loadedMB}/${totalMB} MB`; }
            if (!speedTrackers[speedId]) speedTrackers[speedId] = { lastLoaded: 0, lastTime: now };
            const tracker = speedTrackers[speedId];
            const timeDiff = (now - tracker.lastTime) / 1000;
            if (timeDiff >= 0.5) {
                const bytesDiff = progressEvent.loaded - tracker.lastLoaded;
                const speedMBs = (bytesDiff / (1024 * 1024)) / timeDiff;
                if (speedEl) speedEl.innerHTML = `<i class="fas fa-bolt"></i> ${speedMBs.toFixed(1)} MB/s`;
                tracker.lastLoaded = progressEvent.loaded;
                tracker.lastTime = now;
            }
        };

        const serverMap = [
            { index: 2, name: 'Viettel IDC' },
            { index: 1, name: 'Digital Ocean' },
            { index: 3, name: 'Home NUC' }
        ];

        let completedCount = 0;
        let anySuccess = false;

        const handleServerResult = (i, response) => {
            if (uploadCancelled) return;
            const { index } = serverMap[i];
            if (response?.data?.success) {
                anySuccess = true;
                const dbCreated = response.data.dbCreated;
                const statusMsg = dbCreated
                    ? '<i class="fas fa-check-circle"></i> Tải lên thành công — <i class="fas fa-database"></i> Đã tạo bảng ghi'
                    : '<i class="fas fa-check-circle"></i> Tải lên thành công';
                updateCardStatus(index, 'success', statusMsg);
            } else {
                updateCardStatus(index, 'error', response?.data?.message || 'Tải lên thất bại');
            }
            checkAllDone();
        };

        const handleServerError = (i, error) => {
            if (uploadCancelled) return;
            const { index } = serverMap[i];
            updateCardStatus(index, 'error', error?.message || 'Lỗi kết nối');
            checkAllDone();
        };

        const checkAllDone = () => {
            completedCount++;
            if (completedCount >= 3) {
                if (window._uploadTimerInterval) clearInterval(window._uploadTimerInterval);
                Swal.hideLoading();

                const titleEl = Swal.getTitle();
                if (titleEl) {
                    titleEl.innerHTML = anySuccess
                        ? '<i class="fas fa-check-circle" style="color:#00b894"></i> Tải lên hoàn tất'
                        : '<i class="fas fa-exclamation-triangle" style="color:#d63031"></i> Tải lên thất bại';
                }

                const confirmBtn = Swal.getConfirmButton();
                const cancelBtn = Swal.getCancelButton();
                if (confirmBtn) {
                    confirmBtn.style.display = 'inline-block';
                    confirmBtn.innerHTML = '<i class="fas fa-check"></i> Đóng';
                    confirmBtn.style.backgroundColor = anySuccess ? '#00b894' : '#d63031';
                    confirmBtn.style.borderColor = anySuccess ? '#00b894' : '#d63031';
                }
                if (cancelBtn) cancelBtn.style.display = 'none';

                loadPlugin(localTool);
            }
        };

        const requests = updateService.postPlugin(
            localTool, typeFile, localPath, file,
            makeProgressCallback('progressBar2', 'mbInfo2', 'speed2'),
            makeProgressCallback('progressBar1', 'mbInfo1', 'speed1'),
            makeProgressCallback('progressBar3', 'mbInfo3', 'speed3')
        );

        if (requests) {
            requests.forEach((req, i) => {
                req.then((response) => {
                    handleServerResult(i, response);
                }).catch((error) => {
                    handleServerError(i, error);
                });
            });
        }

        // Retry: tải lại cho 1 server cụ thể
        const progressCallbacks = [
            makeProgressCallback('progressBar2', 'mbInfo2', 'speed2'),
            makeProgressCallback('progressBar1', 'mbInfo1', 'speed1'),
            makeProgressCallback('progressBar3', 'mbInfo3', 'speed3')
        ];
        window._retryUpload = (serverIndex) => {
            const { index } = serverMap[serverIndex];
            const card = document.getElementById(`card${index}`);
            const bar = document.getElementById(`progressBar${index}`);
            const mbInfo = document.getElementById(`mbInfo${index}`);
            const statusEl = document.getElementById(`status${index}`);
            const retryBtn = document.getElementById(`retry${index}`);
            if (card) { card.classList.remove('upload-error', 'upload-success'); }
            if (bar) { bar.style.width = '0%'; bar.textContent = '0%'; }
            if (mbInfo) { const s = mbInfo.querySelector('span:last-child'); if (s) s.textContent = '0.0/0.0 MB'; }
            if (statusEl) { statusEl.style.display = 'none'; }
            if (retryBtn) { retryBtn.style.display = 'none'; }

            completedCount--;

            const urls = [
                `${process.env.REACT_APP_FORWARD_HOST}/v7/admin/plugin/${localTool}`,
                `${process.env.REACT_APP_MY_HOST}/v7/admin/plugin/${localTool}`,
                `${process.env.REACT_APP_FORWARD_HOST3}/v7/admin/plugin/${localTool}`
            ];
            const headers = {
                "Content-Type": "multipart/form-data"
            };

            const retryReq = updateService._uploadToServer(
                urls[serverIndex], file,
                { type: typeFile, localPath },
                headers, progressCallbacks[serverIndex]
            );
            retryReq.then(res => handleServerResult(serverIndex, res))
                    .catch(err => handleServerError(serverIndex, err));
        };
    }



    function table() {
        return (
            <Table className="table-hover" style={{ marginTop: "10px", lineHeight: "15px" }}>
                <thead className="text-primary">
                    <tr>
                        <th className="table-device-mobile">Cập nhập lúc</th>
                        <th className="table-device-mobile">Trạng thái tệp</th>
                        <th className="table-device-mobile">Đường dẫn máy chủ</th>
                        <th className="table-device-mobile">Đường dẫn người dùng</th>
                        <th className='text-center'>Xóa</th>
                    </tr>
                </thead>
                <tbody>
                    {loadFillData()}
                </tbody>
            </Table>
        )
    }


    function showEditSwal(data) {
        const dirPath = `./update/${localTool}/plugin/`;
        // Extract just the filename from url_v2 path
        const fileName = data.url_v2 ? data.url_v2.split('/').pop().split('\\').pop() : '';
        Swal.fire({
            title: `<i class="fas fa-edit" style="margin-right:8px;color:#3498db"></i> Chi tiết Plugin<br><span style="font-size:14px;font-weight:400;color:#888;word-break:break-all">${data.url_v2 || ''}</span>`,
            width: '500px',
            html: `
                <div style="text-align:left;margin-top:12px">
                    <label style="font-weight:600;font-size:14px;color:#525f7f;margin-bottom:4px;display:block">Đường dẫn người dùng</label>
                    <input id="swal-path" class="swal2-input" value="${data.path || ''}" style="margin:0 0 16px 0;width:100%;box-sizing:border-box;font-size:14px;padding:6px 10px">
                    <label style="font-weight:600;font-size:14px;color:#525f7f;margin-bottom:4px;display:block">Tên tệp trên server</label>
                    <input id="swal-url" class="swal2-input" value="${fileName}" style="margin:0 0 16px 0;width:100%;box-sizing:border-box;font-size:14px;padding:6px 10px">
                    <label style="font-weight:600;font-size:14px;color:#525f7f;margin-bottom:4px;display:block">Đường dẫn thư mục</label>
                    <input class="swal2-input" value="${dirPath}" disabled style="margin:0;width:100%;box-sizing:border-box;font-size:14px;padding:6px 10px;background:#f0f0f0;color:#888">
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: '<i class="fas fa-save"></i> Lưu',
            cancelButtonText: '<i class="fas fa-times"></i> Đóng',
            confirmButtonColor: '#00b894',
            cancelButtonColor: '#636e72',
            focusConfirm: false,
            preConfirm: () => {
                return {
                    path: document.getElementById('swal-path').value,
                    url_v2: document.getElementById('swal-url').value
                };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                updateService.putPlugin(localTool, data.id, result.value.path, result.value.url_v2).then((res) => {
                    Swal.fire({
                        icon: res.data.success ? 'success' : 'error',
                        title: res.data.message,
                        timer: 1200,
                        showConfirmButton: false
                    });
                    loadPlugin(localTool);
                }).catch(() => {
                    Swal.fire({ icon: 'error', title: 'Lỗi kết nối' });
                });
            }
        });
    }

    function loadFillData() {
        return plugin.map((data, key) => {
            return (
                <tr onClick={() => showEditSwal(data)} style={{ cursor: "pointer" }} key={key}>
                    <td className="table-device-mobile">{moment(data.createdAt).format('DD/MM/yyyy HH:mm')}</td>
                    <td className="table-device-mobile" style={{ lineHeight: '2' }}>
                        {data.servers ? (() => {
                            const isLoading = data.servers.some(s => s.loading);
                            const okCount = data.servers.filter(s => s.online && s.exists).length;
                            const total = data.servers.length;
                            const bg = isLoading ? '#b2bec3' : okCount === total ? '#00b894' : okCount > 0 ? '#fdcb6e' : '#d63031';
                            const color = (okCount > 0 && okCount < total && !isLoading) ? '#2d3436' : '#fff';
                            return (
                                <span
                                    style={{
                                        display: 'inline-block', padding: '4px 16px', borderRadius: '12px',
                                        fontSize: '13px', fontWeight: 700, color, background: bg,
                                        cursor: 'pointer', ...(isLoading ? { opacity: 0.6 } : {})
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        let html = '';
                                        data.servers.forEach(s => {
                                            let badge, detail;
                                            if (s.loading) {
                                                badge = 'background:#b2bec3;color:#fff';
                                                detail = '<i class="fas fa-spinner fa-spin"></i> Đang kiểm tra...';
                                            } else if (!s.online) {
                                                badge = 'background:#d63031;color:#fff';
                                                detail = '<i class="fas fa-times-circle"></i> Offline';
                                            } else if (s.exists) {
                                                badge = 'background:#00b894;color:#fff';
                                                detail = `<i class="fas fa-check-circle"></i> ${formatFileSize(s.fileSize)}`;
                                            } else {
                                                badge = 'background:#fdcb6e;color:#2d3436';
                                                detail = '<i class="fas fa-exclamation-triangle"></i> Không có tệp';
                                            }
                                            html += `<div style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;margin:4px 0;border-radius:8px;${badge}"><span style="font-weight:600;font-size:13px">${s.label}</span><span style="font-size:12px">${detail}</span></div>`;
                                        });
                                        Swal.fire({
                                            title: `Trạng thái tệp<br><span style="font-size:14px;font-weight:400;color:#888;word-break:break-all">${data.url_v2}</span>`,
                                            html: `<div style="text-align:left">${html}</div>`,
                                            showConfirmButton: true,
                                            confirmButtonText: 'Đóng',
                                            confirmButtonColor: '#3498db',
                                            width: '420px'
                                        });
                                    }}
                                >
                                    {isLoading ? <><i className="fas fa-spinner fa-spin" style={{fontSize:'11px', marginRight:'5px'}}/> Đang tải</> : <><i className="fas fa-server" style={{fontSize:'11px', marginRight:'5px'}}/>{okCount}/{total}</>}
                                </span>
                            );
                        })() : '—'}
                    </td>
                    <td className="table-device-mobile">{data.url_v2}</td>
                    <td className="table-device-mobile">{data.path}</td>

                    <td className='text-center'>
                        <Button style={{ marginLeft: "10px" }} type="button" className="btn btn-danger " onClick={(e) => {
                            e.stopPropagation();
                            Swal.fire({
                                title: 'Xác nhận xóa ?',
                                text: `Điều này sẽ xóa bản cập nhập ${data.url_v2} phần mềm ${localToolName}`,
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Có, xóa bản cập nhập!'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    updateService.deletePlugin(data.tool, data.id, data.url_v2).then((results) => {
                                        const labels = ['api.dhbtools.com', 'api2.dhbtools.com', 'api3.dhbtools.com'];
                                        let html = '';
                                        let anyDbDeleted = false;

                                        results.forEach((r, i) => {
                                            const isOnline = r.status === 'fulfilled' && !(r.value instanceof Error);
                                            const d = isOnline ? r.value?.data : null;
                                            const fileOk = d?.fileDeleted;
                                            const dbOk = d?.dbDeleted;
                                            if (dbOk) anyDbDeleted = true;

                                            let badge, detail;
                                            if (!isOnline) {
                                                badge = 'background:#d63031;color:#fff';
                                                detail = 'Offline';
                                            } else if (dbOk && fileOk) {
                                                badge = 'background:#00b894;color:#fff';
                                                detail = 'DB ✓ &nbsp; File ✓';
                                            } else if (dbOk) {
                                                badge = 'background:#00b894;color:#fff';
                                                detail = 'DB ✓';
                                            } else if (fileOk) {
                                                badge = 'background:#00b894;color:#fff';
                                                detail = 'File ✓';
                                            } else {
                                                badge = 'background:#fdcb6e;color:#2d3436';
                                                detail = 'Không tồn tại';
                                            }

                                            html += `<div style="margin:4px 0"><span style="display:inline-block;padding:2px 10px;border-radius:12px;font-size:12px;font-weight:600;${badge}">${labels[i]} — ${detail}</span></div>`;
                                        });

                                        Swal.fire({
                                            icon: anyDbDeleted ? 'success' : 'warning',
                                            title: anyDbDeleted ? 'Xóa thành công' : 'Xóa file (DB không thay đổi)',
                                            html: html,
                                            showConfirmButton: true,
                                        });

                                        loadPlugin(localTool);
                                    });
                                }
                            })
                        }}><i className="fas fa-trash" style={{ marginRight: '5px' }} /> Xóa</Button>
                    </td>
                </tr >
            )
        })
    };


    return (
        <div className="content">
            <Row>
                <Col md="9">
                    <Card style={{ backgroundColor: '#fff', borderRadius: '20px', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
                        <CardHeader style={{
                            background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                            padding: '18px 24px',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <i className="fas fa-puzzle-piece" style={{ fontSize: '32px', color: '#fff', opacity: 0.9 }}></i>
                            <div style={{ lineHeight: '1.3' }}>
                                <Label style={{ fontSize: '18px', color: '#fff', fontWeight: '700', marginBottom: '0', display: 'block' }}>
                                    Danh sách Plugin
                                </Label>
                                <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>
                                    {plugin.length} bản ghi
                                </span>
                            </div>
                        </CardHeader>
                        <CardBody style={{ padding: '16px 24px' }}>
                            {table()}
                        </CardBody>
                    </Card>
                </Col>

                <Col lg="3" md="4">
                    <Card style={{ backgroundColor: '#fff', borderRadius: '20px', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
                        <CardHeader style={{
                            background: 'linear-gradient(135deg, #198754 0%, #0f5132 100%)',
                            padding: '18px 24px',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <i className="fas fa-plus-circle" style={{ fontSize: '32px', color: '#fff', opacity: 0.9 }}></i>
                            <div style={{ lineHeight: '1.3' }}>
                                <Label style={{ fontSize: '18px', color: '#fff', fontWeight: '700', marginBottom: '0', display: 'block' }}>
                                    Thêm Plugin
                                </Label>
                                <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>
                                    Upload hoặc chọn từ server
                                </span>
                            </div>
                        </CardHeader>
                        <CardBody style={{ padding: '16px 24px' }}>
                            <FormGroup>
                                <Label style={{ fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Nguồn dữ liệu</Label>
                                <Select
                                    placeholder={typeFile}
                                    value={typeFile}
                                    onChange={(e) => {
                                        setTypeFile(e.value)
                                        if (e.value == "Chọn từ server") {
                                            updateService.getExplorerFiles("").then((result) => {
                                                var result = result.data.data
                                                var lst = []
                                                for (let i = 0; i < result.length; i++) {
                                                    lst.push({ value: result[i], label: result[i] });
                                                }
                                                setLstFolder(lst)
                                                setFolderSelected("./update/shared/plugin")
                                                updateService.getExplorerFiles("./update/shared/plugin").then((result) => {
                                                    var result = result.data.data
                                                    var lst = []
                                                    for (let i = 0; i < result.length; i++) {
                                                        lst.push({ value: result[i], label: result[i] });
                                                    }
                                                    setLstFile(lst)
                                                    setFileSelected("")
                                                })
                                            })
                                        }
                                    }}
                                    options={[
                                        { value: 'Tải lên file', label: 'Tải lên file' },
                                        { value: 'Chọn từ server', label: 'Chọn từ server' }
                                    ]}
                                />

                                {typeFile == 'Tải lên file'
                                    ?
                                    <>
                                        <Label style={{ marginTop: "1rem", fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Đường dẫn người dùng</Label>
                                        <Input style={{ maxHeight: "100%", borderRadius: '20px' }}
                                            value={localPath}
                                            id="localPath"
                                            onChange={(e) => { setLocalPath(e.target.value) }}
                                        />

                                        <Label style={{ marginTop: "1rem", fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Tệp tin</Label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Button color="info" size="sm" onClick={() => document.getElementById('file').click()} style={{ borderRadius: '20px', fontSize: '14px' }}>
                                                <i className="fas fa-cloud-upload-alt" style={{ marginRight: '5px' }} /> Chọn tệp
                                            </Button>
                                            <span style={{ fontSize: '15px', color: '#666', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {selectedFile ? selectedFile.name : 'Chưa chọn tệp'}
                                            </span>
                                            <Input type="file" id="file" style={{ display: 'none' }} onChange={(e) => { setSelectedFile(e.target.files[0]) }} />
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div style={{ paddingTop: "15px" }}>
                                            <Label style={{ fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Thư mục</Label>
                                            <Select
                                                placeholder={folderSelected}
                                                value={folderSelected}
                                                onChange={(e) => {
                                                    setFolderSelected(e.value)
                                                    updateService.getExplorerFiles(e.value).then((result) => {
                                                        var result = result.data.data
                                                        var lst = []
                                                        for (let i = 0; i < result.length; i++) {
                                                            lst.push({ value: result[i], label: result[i] });
                                                        }
                                                        setLstFile(lst)
                                                        setFileSelected("")
                                                    })
                                                }}
                                                options={lstFolder}
                                            />
                                        </div>

                                        <div style={{ paddingTop: "15px" }}>
                                            <Label style={{ fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Tệp tin</Label>
                                            <Select
                                                placeholder={fileSelected}
                                                value={fileSelected}
                                                onChange={(e) => { setFileSelected(e.value) }}
                                                options={lstFile}
                                            />
                                        </div>

                                        <Label style={{ marginTop: "1rem", fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Local Path</Label>
                                        <Input style={{ maxHeight: "100%", borderRadius: '20px' }}
                                            value={localPath}
                                            id="localPath"
                                            onChange={(e) => { setLocalPath(e.target.value) }}
                                        />
                                    </>
                                }
                            </FormGroup>
                        </CardBody>

                        <CardFooter style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0' }}>
                            <Button
                                style={{ width: "100%", borderRadius: '20px', fontSize: '14px', padding: '8px 16px' }}
                                color="success"
                                onClick={postPlugin}
                            >
                                <i className="fas fa-plus" style={{ marginRight: '5px' }} /> Thêm mới
                            </Button>
                        </CardFooter>
                    </Card>
                </Col>
            </Row>

        </div>
    )
}

export default Orders